import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DataService } from '../services/data.service';
import { API_ENDPOINT$ } from '../shared/index';
@Injectable({
  providedIn: 'root'
})
export class SiteService {
  private getTreeConfigurationUrl = `${API_ENDPOINT$}/common/getTreeConfiguration`;
  private fetchIssuedAlertsUrl = `${API_ENDPOINT$}/common/fetchIssuedAlerts`;
  private fetchGeneratedFaultsUrl = `${API_ENDPOINT$}/common/fetchGeneratedFaults`;
  private setAlertIsReadByRIdsUrl = `${API_ENDPOINT$}/site/setAlertIsReadByRIds`;
  private deleteIssuedAlertByRIdsUrl = `${API_ENDPOINT$}/site/deleteIssuedAlertByRIds`;
  private exportIssuedAlertsUrl = `${API_ENDPOINT$}/site/exportIssuedAlerts`;
  private fetchTaggedDataUrl = `${API_ENDPOINT$}/site/fetchTaggedData`;
  private saveDataTagUrl = `${API_ENDPOINT$}/site/saveDataTag`;
  private getLoadsBySiteIdUrl = `${API_ENDPOINT$}/common/getLoadsBySiteId`;
  private getDeepDiveDataUrl = `${API_ENDPOINT$}/energy/getDeepDiveData`;
  private meterOfLoadUrl = `${API_ENDPOINT$}/rest/getMeterOfLoad`;
  private lastRealtimeDataForLoadOfMeterViewUrl = `${API_ENDPOINT$}/common/getLastRealtimeDataForLoad`;
  private saveSiteDetailsUrl = `${API_ENDPOINT$}/manageproject/saveSiteDetails`;
  private getAvailableTimezonesUrl = `${API_ENDPOINT$}/common/getAvailableTimezones`;
  private uploadAttachmentUrl = `${API_ENDPOINT$}/common/uploadAttachment`;
  private getShiftsBySiteIdUrl = `${API_ENDPOINT$}/common/getShiftsBySiteId`;
  private saveShiftsForSiteUrl = `${API_ENDPOINT$}/manageproject/saveShiftsForSite`;
  private getSiteDetailsUrl = `${API_ENDPOINT$}/common/getSiteDetails`;
  private saveConnDetailsUrl = `${API_ENDPOINT$}/manageproject/saveConnDetails`;
  private getConnectionDetailsUrl = `${API_ENDPOINT$}/manageproject/getConnectionDetails`;
  private getProcessAndLoadsBySiteIdUrl = `${API_ENDPOINT$}/common/getProcessAndLoadsBySiteId`;
  private saveProcessUrl = `${API_ENDPOINT$}/manageproject/saveProcessForSite`;
  private saveGroupsForSiteUrl = `${API_ENDPOINT$}/manageproject/saveGroupsForSite`;
  private getGroupsAndLoadsBySiteIdUrl = `${API_ENDPOINT$}/common/getGroupsAndLoadsBySiteId`;
  private getLoadVerticesOfSiteForGroupsUrl = `${API_ENDPOINT$}/common/getLoadVerticesOfSiteForGroups`;
  private getUtilityLoadVerticesOfSiteForGroupsUrl = `${API_ENDPOINT$}/common/getUtilityLoadVerticesOfSiteForGroups`;
  private getLoadVerticesOfSiteBasedOnUtilityUrl = `${API_ENDPOINT$}/common/getLoadVerticesOfSiteBasedOnUtility`;
  private getUtilityGroupsAndLoadsBySiteIdUrl = `${API_ENDPOINT$}/common/getUtilityGroupsAndLoadsBySiteId`;
  private saveUtilityGroupForSiteUrl = `${API_ENDPOINT$}/manageproject/saveUtilityGroupForSite`;
  // Load
  private getUnassignedMetersOfRoleUrl = `${API_ENDPOINT$}/common/getUnassignedMetersOfRole`;
  private getAllSitesUrl = `${API_ENDPOINT$}/common/getAllSites`;
  private getLoadSubTypeUrl = `${API_ENDPOINT$}/common/getLoadSubType`;
  private saveLoadUrl = `${API_ENDPOINT$}/manageproject/saveLoad`;
  private getLoadDetailUrl = `${API_ENDPOINT$}/common/getLoadDetail`;
  private getDigitalOutputMappingUrl = `${API_ENDPOINT$}/common/getDigitalOutputMapping`;
  private getAllWidgetsBySiteIdUrl = `${API_ENDPOINT$}/common/getAllWidgetsConfigBySiteId`;
  private saveWidgetsConfigUrl = `${API_ENDPOINT$}/manageproject/saveWidgetsConfig`;
  private getAllReportConfigBySiteIdUrl = `${API_ENDPOINT$}/site/getAllReportConfigBySiteId`;
  private saveReportConfigUrl = `${API_ENDPOINT$}/site/saveReportConfig`;
  private restoreReportConfigUrl = `${API_ENDPOINT$}/site/restoreReportConfig`;
  private getAvailableMeterForLoadUrl = `${API_ENDPOINT$}/meter/getAvailableMeterForLoad`;
  private mapMeterToLoadUrl = `${API_ENDPOINT$}/meter/mapMeterToLoad`;
  private saveDAQLayoutForLoadUrl = `${API_ENDPOINT$}/meter/saveDAQLayoutForLoad`;
  private getLoadsByProcessNameUrl = `${API_ENDPOINT$}/common/getLoadsByProcessName`;
  // Alert config
  private getAlertsBySiteIdUrl = `${API_ENDPOINT$}/common/getAlertsBySiteId`;
  private getAlertsListBySiteIdUrl = `${API_ENDPOINT$}/common/getAlertsListBySiteId`;
  private activateAlertsUrl = `${API_ENDPOINT$}/common/activateAlerts`;
  private deactivateAlertsUrl = `${API_ENDPOINT$}/common/deactivateAlerts`;
  private getUserEmailsBySiteIdUrl = `${API_ENDPOINT$}/common/getUserEmailsBySiteId`;
  private getNonHydraulicLoadsBySiteIdUrl = `${API_ENDPOINT$}/common/getNonHydraulicLoadsBySiteId`;
  private getLoadsbasedOnTypeAndSubTypeUrl = `${API_ENDPOINT$}/common/getLoadsBasedOnTypeAndSubType`;
  private getSiteLevelSensorDetailsUrl = `${API_ENDPOINT$}/common/getSiteLevelSensorDetails`;
  private saveAlertForSiteUrl = `${API_ENDPOINT$}/manageproject/saveAlertForSite`;
  private exportAlertsUrl = `${API_ENDPOINT$}/site/exportAlerts`;
  // MIS
  private getMisServicesUrl = `${API_ENDPOINT$}/common/getMisServicesList`;
  private saveMISUrl = `${API_ENDPOINT$}/manageproject/saveMIS`;
  private createNewServiceUrl = `${API_ENDPOINT$}/manageproject/createNewService`;
  private saveCommissionRemarkUrl = `${API_ENDPOINT$}/manageproject/saveCommissionRemark`;
  private addVirtualGroupForSiteUrl = `${API_ENDPOINT$}/manageproject/addVirtualGroupForSite`;
  private saveTreeConfigurationUrl = `${API_ENDPOINT$}/manageproject/saveTreeConfiguration`;
  private getCommissionRemarkUrl = `${API_ENDPOINT$}/manageproject/getCommissionRemark`;
  private getVirtualGroupsForSiteUrl = `${API_ENDPOINT$}/manageproject/getVirtualGroupsForSite`;
  // Node
  private getSensorDetailsBasedOnLoadIdUrl = `${API_ENDPOINT$}/common/getSensorDetailsBasedOnLoadId`;
  private getOptionsByClassNameUrl = `${API_ENDPOINT$}/common/getOptionsByClassName`;
  private getAltSourcesDetailsUrl = `${API_ENDPOINT$}/common/getAltSourcesDetails`;
  private getConnectedIrradianceSensorsBySiteIdUrl = `${API_ENDPOINT$}/common/getConnectedIrradianceSensorsBySiteId`;
  private saveAltSourcesDetailsUrl = `${API_ENDPOINT$}/manageproject/saveAltSourcesDetails`;
  private getStringDetailsUrl = `${API_ENDPOINT$}/manageproject/getStringDetails`;
  private getInverterMakeOfSolarProcessUrl = `${API_ENDPOINT$}/manageproject/getInvertersOfSolarProcess`;
  private getsaveStringsAndPvmoduleDetailsUrl = `${API_ENDPOINT$}/manageproject/saveStringsAndPvmoduleDetails`;
  private getsavePvmoduleDetailsUrl = `${API_ENDPOINT$}/manageproject/savePvmoduleDetails`;
  private getSolarAreasOfSiteUrl = `${API_ENDPOINT$}/manageproject/getSolarAreasOfSite`;
  private getSolarProcessesOfSiteUrl = `${API_ENDPOINT$}/manageproject/getSolarProcessesOfSite`;
  private getMetersBySiteIdAndMeterRolesUrl = `${API_ENDPOINT$}/common/getMetersBySiteIdAndMeterRoles`;
  private getdeleteAttachmentByRIdsUrl = `${API_ENDPOINT$}/common/deleteAttchmentByImageId`;
  private getsaveAttachmentByRIdsUrl = `${API_ENDPOINT$}/site/saveAttchmentByImageId`;
  private getProcessBySiteIdUrl = `${API_ENDPOINT$}/common/getProcessBySiteId`;
  private getSaveDCUUrl = `${API_ENDPOINT$}/manageproject/addDCU`;
  private getAddMeterUrl = `${API_ENDPOINT$}/manageproject/addMeter`;
  private checkUniqueMeterIdsOfSiteUrl = `${API_ENDPOINT$}/common/checkUniqueMeterIdsOfSite`;
  private checkUniqueInsiteMetersOfDCUUrl = `${API_ENDPOINT$}/common/checkUniqueInsiteMetersOfDCU`;
  // Form 12
  nodeInfoSubject: Subject<any>;
  // Plant Navigation
  private getSensorsConnectedToSiteUrl = `${API_ENDPOINT$}/common/getSensorsConnectedToSite`;
  private getAttachmentsForNodeUrl = `${API_ENDPOINT$}/common/getAttachmentsForNode`;
  private getSensorTrendForGadgetsUrl = `${API_ENDPOINT$}/common/getSensorTrendForGadgets`;
  private getAlertCountForNodeUrl = `${API_ENDPOINT$}/common/getAlertCountForNode`;

  private getAllDCUForSiteUrl = `${API_ENDPOINT$}/common/getAllDCUforSite`;

  // Overview page
  private fetchUtilityConsumptionInfoUrl = `${API_ENDPOINT$}/common/fetchUtilityConsumptionInfo`;
  private getCarbonFootPrintUrl = `${API_ENDPOINT$}/common/getCarbonFootPrint`;
  private consumotionBreakUpUrl = `${API_ENDPOINT$}/common/getConsumptionBreakUp`;
  private costBreakUpUrl = `${API_ENDPOINT$}/common/getCostBreakUp`;
  private getActiveAlertsOfSiteUrl = `${API_ENDPOINT$}/common/getActiveAlertsOfSite`;
  // Meter Inventory
  private getAllMetersforSiteIdUrl = `${API_ENDPOINT$}/common/getAllMetersforSiteId`;
  // DCU Inventory
  private getDCUBySiteIdUrl = `${API_ENDPOINT$}/common/getDCUBySiteId`;
  // Manage Solar Scheduler
  private getmanageSolarSchedulerUrl = `${API_ENDPOINT$}/report/manageSolarScheduler`;
  private generateTriggerMail = `${API_ENDPOINT$}/report/triggerMail`;
  private getKPITrendsChartUrl = `${API_ENDPOINT$}/common/getKPITrendsChart`;
  private getDemandSupplyTrendsChartUrl = `${API_ENDPOINT$}/energy/getDemandSupplyTrendsChart`;
  private getMeterRolesBasedOnkpiUtilityUrl = `${API_ENDPOINT$}/common/getAllMeterRolesForkpiUtility`;
  private getAllLoadTypesForkpiUtilityUrl = `${API_ENDPOINT$}/common/getAllLoadTypesForkpiUtility`;

  constructor(private dataService: DataService) {
    this.nodeInfoSubject = new Subject<any>();
  }

  private getServiceChartInfoUrl = `${API_ENDPOINT$}/common/getServiceChartInfo`;
  // add building
  private createNewBuildingUrl = `${API_ENDPOINT$}/manageproject/createNewBuilding`;
  private linkLoadToBuildingUrl = `${API_ENDPOINT$}/manageproject/linkLoadToBuilding`;
  private getBuildingBySiteIdUrl = `${API_ENDPOINT$}/common/getBuildingBySiteId`;

  public getTreeConfiguration(siteId: string, params: any): Observable<any> {
    return this.dataService.postData(
      `${this.getTreeConfigurationUrl}/${siteId}`,
      params
    );
  }
  public fetchIssuedAlerts(
    siteId: string,
    fromDate: any,
    toDate: any,
    alertForType: string
  ): Observable<any> {
    const model = { siteId, fromDate, toDate, alertForType };
    return this.dataService.postData(this.fetchIssuedAlertsUrl, model);
  }
  public fetchGeneratedFaults(
    siteId: string,
    fromDate: any,
    toDate: any
  ): Observable<any> {
    const model = { siteId, fromDate, toDate };
    return this.dataService.postData(this.fetchGeneratedFaultsUrl, model);
  }
  public setAlertIsReadByRIds(rIds: any, isRead: boolean): Observable<any> {
    const model = { isRead, rIds };
    return this.dataService.postData(this.setAlertIsReadByRIdsUrl, model);
  }
  public deleteIssuedAlertByRIds(rIds: any): Observable<any> {
    const model = { rIds };
    return this.dataService.postData(this.deleteIssuedAlertByRIdsUrl, model);
  }
  public getExportIssuedAlertsUrl(): string {
    return this.exportIssuedAlertsUrl;
  }
  public fetchTaggedData = (
    siteId: string,
    fromDate: string,
    toDate: string,
    dataTagModel: any
  ): Observable<any> => {
    const model = {
      siteId: siteId,
      fromDate: fromDate,
      toDate: toDate,
      dataTagDetails: JSON.stringify(dataTagModel)
    };
    return this.dataService.postData(this.fetchTaggedDataUrl, model, false);
  };
  public saveDataTag = (dataTagDetails: any) => {
    return this.dataService.postData(this.saveDataTagUrl, dataTagDetails);
  };
  public getLoadsBySiteId(siteId: string): Observable<any> {
    return this.dataService.getData(this.getLoadsBySiteIdUrl + '/' + siteId);
  }
  public getDeepDiveData(model: any): Observable<any> {
    return this.dataService.postData(this.getDeepDiveDataUrl, model);
  }
  public getMeterOfLoad = (siteId: string, loadId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.meterOfLoadUrl}/${siteId}/${loadId}`
    );
  };
  public getLastRealtimeDataForLoadOfMeterView = (
    siteId: string,
    meterId: string
  ): Observable<any> => {
    const model = { siteId: siteId, meterId: meterId };
    return this.dataService.postData(
      this.lastRealtimeDataForLoadOfMeterViewUrl,
      model,
      false
    );
  };
  public saveSiteDetails = (siteDetails: any): Observable<any> => {
    return this.dataService.postData(this.saveSiteDetailsUrl, siteDetails);
  };
  public getAvailableTimezones = (): Observable<any> => {
    return this.dataService.getData(this.getAvailableTimezonesUrl);
  };
  public uploadDocument = (
    formData: any,
    documentType: string,
    comment: string,
    siteId: string
  ): Observable<any> => {
    return this.dataService.uploadDocument(
      `${this.uploadAttachmentUrl}?documentType=${documentType}&comment=${comment}&siteId=${siteId}`,
      formData
    );
  };
  public getShiftsBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getShiftsBySiteIdUrl}/${siteId}`);
  };
  public saveShifts = (shifts: any, siteId: string): Observable<any> => {
    return this.dataService.postData(
      `${this.saveShiftsForSiteUrl}/${siteId}`,
      shifts,
      true
    );
  };
  public getSiteDetails = (): Observable<any> => {
    return this.dataService.getData(`${this.getSiteDetailsUrl}`);
  };
  public saveConnDetails = (model: any): Observable<any> => {
    return this.dataService.postData(this.saveConnDetailsUrl, model);
  };
  public getConnectionDetails = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      this.getConnectionDetailsUrl + '/' + siteId
    );
  };
  public getProcessAndLoadsBySiteId(
    siteId: string,
    needMeterInfo: boolean
  ): Observable<any> {
    return this.dataService.getData(
      this.getProcessAndLoadsBySiteIdUrl + '/' + siteId + '/' + needMeterInfo,
      true
    );
  }
  public saveProcess(params: any): Observable<any> {
    return this.dataService.postData(this.saveProcessUrl, params);
  }
  public saveGroupsForSite = (params: any): Observable<any> => {
    return this.dataService.postData(this.saveGroupsForSiteUrl, params);
  };
  public getGroupsAndLoadsBySiteId = (
    siteId: string,
    needMeterInfo: boolean
  ) => {
    return this.dataService.getData(
      `${this.getGroupsAndLoadsBySiteIdUrl}/${siteId}/${needMeterInfo}`
    );
  };
  public getLoadVerticesOfSiteForGroups = (siteId: string) => {
    return this.dataService.getData(
      `${this.getLoadVerticesOfSiteForGroupsUrl}/${siteId}`
    );
  };

  public getUtilityLoadVerticesOfSiteForGroups = (
    siteId: string,
    kpiName: string
  ) => {
    return this.dataService.getData(
      `${this.getUtilityLoadVerticesOfSiteForGroupsUrl}/${siteId}/${kpiName}`
    );
  };

  public getLoadsBasedOnUtility = (siteId: string, kpiName: string) => {
    return this.dataService.getData(
      `${this.getLoadVerticesOfSiteBasedOnUtilityUrl}/${siteId}/${kpiName}`
    );
  };

  public fetchUtilityGroupsAndLoads = (data) => {
    return this.dataService.getData(
      `${this.getUtilityGroupsAndLoadsBySiteIdUrl}/${data.siteId}/${data.kpiName}/${data.needMeterInfo}`
    );
  };

  public saveUtilityGroupsForSite = (params: any): Observable<any> => {
    return this.dataService.postData(this.saveUtilityGroupForSiteUrl, params);
  };

  // Load
  public getLoadsByProcessName = (
    siteId: string,
    processName: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getLoadsByProcessNameUrl}/${siteId}/${processName}`
    );
  };
  public getAllSites = () => {
    return this.dataService.getData(this.getAllSitesUrl);
  };
  public getUnassignedMetersOfRole = (
    siteId: any,
    meterRole: string,
    kpiUtility: string
  ) => {
    return this.dataService.getData(
      `${this.getUnassignedMetersOfRoleUrl}/${siteId}/${meterRole}/${kpiUtility}`
    );
  };
  public getLoadSubType = (type: any): Observable<any> => {
    return this.dataService.getData(`${this.getLoadSubTypeUrl}/${type}`);
  };
  public saveLoad = (model: any): Observable<any> => {
    return this.dataService.postData(this.saveLoadUrl, model);
  };
  public getLoadDetail = (siteId: string, loadId: any): Observable<any> => {
    return this.dataService.getData(
      `${this.getLoadDetailUrl}/${loadId}/${siteId}`
    );
  };
  public getDigitalOutputMapping = (model: any): Observable<any> => {
    return this.dataService.postData(this.getDigitalOutputMappingUrl, model);
  };
  public getAllWidgetsBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getAllWidgetsBySiteIdUrl}/${siteId}`
    );
  };
  public saveWidgetsConfig = (
    widgets: any,
    siteId: string
  ): Observable<any> => {
    return this.dataService.postData(
      `${this.saveWidgetsConfigUrl}/${siteId}`,
      widgets
    );
  };
  public getAllReportConfigBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getAllReportConfigBySiteIdUrl}/${siteId}`
    );
  };
  public saveReportConfig = (configs: any, siteId: string): Observable<any> => {
    return this.dataService.postData(
      `${this.saveReportConfigUrl}/${siteId}`,
      configs
    );
  };
  public restoreDefault = (
    siteId: string,
    reportType: string
  ): Observable<any> => {
    const reportTypeParam = { reportType: reportType };
    return this.dataService.postData(
      `${this.restoreReportConfigUrl}/${siteId}`,
      reportTypeParam
    );
  };
  public getAvailableMeterForLoad = (): Observable<any> => {
    return this.dataService.getData(`${this.getAvailableMeterForLoadUrl}`);
  };
  public mapMeterToLoad = (model: any): Observable<any> => {
    return this.dataService.postData(`${this.mapMeterToLoadUrl}`, model);
  };
  public saveDACDetail = (model: any): Observable<any> => {
    return this.dataService.postData(`${this.saveDAQLayoutForLoadUrl}`, model);
  };
  // Alert Config
  public getAlertsBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getAlertsBySiteIdUrl}/${siteId}`);
  };
  public getAlertsListBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getAlertsListBySiteIdUrl}/${siteId}`
    );
  };
  public activateAlerts = (model: any): Observable<any> => {
    return this.dataService.postData(this.activateAlertsUrl, model);
  };
  public deactivateAlerts = (model: any): Observable<any> => {
    return this.dataService.postData(this.deactivateAlertsUrl, model);
  };
  public getUserEmailsBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getUserEmailsBySiteIdUrl}/${siteId}`
    );
  };
  public getNonHydraulicLoadsBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getNonHydraulicLoadsBySiteIdUrl}/${siteId}`
    );
  };
  public getLoadsBasedOnTypeAndSubType = (model: any): Observable<any> => {
    return this.dataService.postData(
      this.getLoadsbasedOnTypeAndSubTypeUrl,
      model
    );
  };
  public getSiteLevelSensorDetails = (model: any): Observable<any> => {
    return this.dataService.postData(this.getSiteLevelSensorDetailsUrl, model);
  };
  public saveAlertForSite = (model: any): Observable<any> => {
    return this.dataService.postData(this.saveAlertForSiteUrl, model);
  };
  public exportAlerts = (siteId: string): string => {
    return `${this.exportAlertsUrl}/${siteId}`;
  };
  // MIS report
  public getMisServices = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getMisServicesUrl}/${siteId}`);
  };
  public saveMIS = (siteId: string, model: any): Observable<any> => {
    const url = `${this.saveMISUrl}/${siteId}`;
    return this.dataService.postData(url, model);
  };
  public createNewService = (model: any): Observable<any> => {
    return this.dataService.postData(this.createNewServiceUrl, model);
  };
  public saveCommissionRemark = (siteId, commissionRemark): Observable<any> => {
    const model = { commissionRemark: commissionRemark, siteId: siteId };
    return this.dataService.postData(this.saveCommissionRemarkUrl, model);
  };
  public addVirtualGroupForSite = (model: any): Observable<any> => {
    return this.dataService.postData(this.addVirtualGroupForSiteUrl, model);
  };
  public saveTreeConfiguration = (
    siteId,
    treeConfiguration: any
  ): Observable<any> => {
    return this.dataService.postData(
      `${this.saveTreeConfigurationUrl}/${siteId}`,
      treeConfiguration
    );
  };
  public getCommissionRemark = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getCommissionRemarkUrl}/${siteId}`);
  };
  public getVirtualGroupsForSite = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getVirtualGroupsForSiteUrl}/${siteId}`
    );
  };
  // NODE
  public getSensorDetailsBasedOnLoadRId = (model: any): Observable<any> => {
    return this.dataService.postData(
      `${this.getSensorDetailsBasedOnLoadIdUrl}`,
      model
    );
  };
  public getOptionsByClassName = (type: string): Observable<any> => {
    return this.dataService.getData(`${this.getOptionsByClassNameUrl}/${type}`);
  };

  public getAltSourcesDetails = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getAltSourcesDetailsUrl}/${siteId}`
    );
  };
  public getConnectedIrradiationSensor = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getConnectedIrradianceSensorsBySiteIdUrl}/${siteId}`
    );
  };
  public saveAltSourcesDetails = (
    siteId: string,
    model: any
  ): Observable<any> => {
    return this.dataService.postData(
      `${this.saveAltSourcesDetailsUrl}/${siteId}`,
      model
    );
  };
  public getStringDetails = (
    solarProcess: string,
    inverterMake: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getStringDetailsUrl}/${solarProcess}/${inverterMake}`
    );
  };
  public getInverterMakeOfSolarProcess = (
    siteId: string,
    solarProcess: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getInverterMakeOfSolarProcessUrl}/${siteId}/${solarProcess}`
    );
  };
  public saveStringsAndPvModules = (
    siteId: string,
    stringsAndModules: any
  ): Observable<any> => {
    return this.dataService.postData(
      `${this.getsaveStringsAndPvmoduleDetailsUrl}/${siteId}`,
      stringsAndModules
    );
  };
  public savePvModules = (
    siteId: string,
    stringsAndModules: any
  ): Observable<any> => {
    return this.dataService.postData(
      `${this.getsavePvmoduleDetailsUrl}/${siteId}`,
      stringsAndModules
    );
  };
  public getSolarAreasOfSite = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getSolarAreasOfSiteUrl}/${siteId}`);
  };
  public getSolarProcessesBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getSolarProcessesOfSiteUrl}/${siteId}`
    );
  };
  public getMetersBySiteIdAndMeterRoles = (
    siteId: string,
    meteRoles: any
  ): Observable<any> => {
    return this.dataService.postData(
      `${this.getMetersBySiteIdAndMeterRolesUrl}/${siteId}`,
      meteRoles
    );
  };
  public sendNodeInfoSubject = (value: any) => {
    this.nodeInfoSubject.next(value);
  };
  public getNodeInfoSubject = (): Observable<any> => {
    return this.nodeInfoSubject.asObservable();
  };
  public unSubscribeNodeInfoSubject = () => {
    this.nodeInfoSubject.observers = [];
  };
  public deleteAttachmentByRIds = (imageIds: any): Observable<any> => {
    return this.dataService.postData(
      `${this.getdeleteAttachmentByRIdsUrl}`,
      imageIds
    );
  };
  public saveAttachmentByRIds = (imageIds: any): Observable<any> => {
    return this.dataService.postData(
      `${this.getsaveAttachmentByRIdsUrl}`,
      imageIds
    );
  };
  public getProcessBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getProcessBySiteIdUrl}/${siteId}`);
  };
  public getSensorsConnectedToSite = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getSensorsConnectedToSiteUrl}/${siteId}`
    );
  };
  public getAttachmentsForNode = (model: any): Observable<any> => {
    return this.dataService.postData(`${this.getAttachmentsForNodeUrl}`, model);
  };
  public getSensorTrendForGadgets(params: any): Observable<any> {
    return this.dataService.postData(this.getSensorTrendForGadgetsUrl, params);
  }
  public saveDCU(params: any): Observable<any> {
    return this.dataService.postData(this.getSaveDCUUrl, params);
  }

  public getAlertCountForNode(params: any): Observable<any> {
    return this.dataService.postData(
      this.getAlertCountForNodeUrl,
      params,
      false
    );
  }
  public getAllDCUBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getAllDCUForSiteUrl}/${siteId}`);
  };
  public checkUniqueMeterIdsOfSite = (
    siteId: string,
    meterId: String
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.checkUniqueMeterIdsOfSiteUrl}/${siteId}/${meterId}`,
      false,
      true
    );
  };
  public checkUniqueInsiteMetersOfDCU = (
    siteId: string,
    dcuId: String,
    insiteMeterId: String
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.checkUniqueInsiteMetersOfDCUUrl}/${siteId}/${dcuId}/${insiteMeterId}`,
      false,
      true
    );
  };
  public insertMeter(params: any): Observable<any> {
    return this.dataService.postData(this.getAddMeterUrl, params);
  }
  public fetchUtilityConsumptionInfo = (
    siteId: string,
    startDate: string,
    endDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.fetchUtilityConsumptionInfoUrl}/${siteId}/${startDate}/${endDate}`
    );
  };
  public getCarbonFootPrint = (params: any): Observable<any> => {
    const paramStr = `${params.siteId}/${params.processName}/${params.timeBase}/${params.startDate}/${params.endDate}`;
    return this.dataService.getData(
      `${this.getCarbonFootPrintUrl}/${paramStr}`
    );
  };
  public getConsumptionBreakUp = (
    siteId: string,
    startDate: string,
    endDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.consumotionBreakUpUrl}/${siteId}/${startDate}/${endDate}`
    );
  };
  public getCostBreakUp = (
    siteId: string,
    startDate: string,
    endDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.costBreakUpUrl}/${siteId}/${startDate}/${endDate}`
    );
  };
  public getActiveAlertsOfSite = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getActiveAlertsOfSiteUrl}/${siteId}`
    );
  };
  public getAllMetersforSiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(
      `${this.getAllMetersforSiteIdUrl}/${siteId}`
    );
  };
  public getDCUBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getDCUBySiteIdUrl}/${siteId}`);
  };
  public insertSolarData = (params: any): Observable<any> => {
    return this.dataService.postData(this.getmanageSolarSchedulerUrl, params);
  };
  public getGenerateTriggerMail = (
    siteId: string,
    date: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.generateTriggerMail}/${siteId}/${date}`
    );
  };
  public getKPITrendsChart = (
    siteId: string,
    startDate: string,
    endDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getKPITrendsChartUrl}/${siteId}/${startDate}/${endDate}`
    );
  };
  public getDemandSupplyTrendsChart = (
    siteId: string,
    startDate: string,
    endDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getDemandSupplyTrendsChartUrl}/${siteId}/${startDate}/${endDate}`,
      true
    );
  };
  public createNewBuilding = (model: any): Observable<any> => {
    return this.dataService.postData(this.createNewBuildingUrl, model);
  };

  public linkLoadToBuilding = (data: any): Observable<any> => {
    return this.dataService.postData(this.linkLoadToBuildingUrl, data);
  };

  public getBuildingBySiteId = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getBuildingBySiteIdUrl}/${siteId}`);
  };

  public getServiceChartInfo = (
    siteId: string,
    misService: string,
    timeBase: string,
    startDate: string,
    endDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getServiceChartInfoUrl}/${siteId}/${misService}/${timeBase}/${startDate}/${endDate}`
    );
  };

  /**
   * Method to call API getMeterRolesBasedOnkpiUtility
   *
   * @param {string} kpiUtility
   * @memberof SiteService
   */
  public getMeterRolesBasedOnkpiUtility = (
    kpiUtility: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getMeterRolesBasedOnkpiUtilityUrl}/${kpiUtility}`
    );
  };

  /**
   * Method to call API getAllLoadTypesForkpiUtility
   *
   * @param {string} kpiUtility
   * @memberof SiteService
   */
  public getAllLoadTypesForkpiUtility = (
    kpiUtility: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getAllLoadTypesForkpiUtilityUrl}/${kpiUtility}`
    );
  };
}
